import React, { useMemo } from 'react';
import axios from 'axios';
import { element } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useAuth } from '~/services';
import { ApiContext } from './context';

/**
 * Provider de API para o fluxo Becompliance (API v3).
 */
export const BeApiProvider = ({ children }) => {
  const { token } = useAuth();
  const { i18n } = useTranslation();

  const baseURL = `${import.meta.env.VITE_API_URL}/api/v3`;

  const getApi = useMemo(() => {
    const headers = {
      'Accept-Language': i18n.language,
      locale: i18n.language,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    return () => {
      const config = {
        baseURL,
        headers: { ...headers },
      };
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return axios.create(config);
    };
  }, [token, i18n.language]);

  const value = useMemo(() => ({ getApi, baseURL }), [getApi, baseURL]);

  return (
    <ApiContext.Provider value={value}>
      {children}
    </ApiContext.Provider>
  );
};

BeApiProvider.propTypes = {
  children: element.isRequired,
};
